import { Box, Button, Grid, Typography } from "@mui/material";
import { NavLink } from 'react-router-dom';
import ManageAssessmentsTable from "../../components/ManageAssessmentsTable/ManageAssessmentsTable";
import AssessmentTemplateCards from "../../components/ManageAssessmentsTable/AssessmentTemplateCards";


const ManageJobs: React.FC = () => {
    return (
        <Box sx={{
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px', position: 'relative' }}>
                <Box sx={{ flex: 1 }} />
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ textAlign: 'center' }}
                >
                    Assessments
                </Typography>
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <NavLink to={"/manage-assessments/create"}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "var(--ttg-green)",
                                "&:hover": {
                                    backgroundColor: "var(--button-hover-green)"
                                }
                            }}>
                            Create New Assessment
                        </Button>
                    </NavLink>
                </Box>
            </Box>
            <AssessmentTemplateCards />
            <ManageAssessmentsTable />
        </Box>
    );
}

export default ManageJobs;